import { ResponsiveUtilities, SiteUtilities } from './utils';
const pricingDropdown = function () {
  const arrowEle = document.createElement('i');
  arrowEle.className = 'icon-arrow-down';
  const overlayEle = jQuery('.browser-mockup .pricing-dropdown-overlay, .pricing-table-row .pricing-dropdown-overlay');
  const pricingTableEles = jQuery('.browser-mockup, .pricing-table-row');
  const pricingProductInputEle = jQuery('.pricing-product-input');
  const pricingDropdownEle = jQuery('.pricing-product-dropdown');
  const updateActiveDescendant = (selectedEle) => {
    const selectedProductId = jQuery(selectedEle).attr('id');
    jQuery(pricingProductInputEle).attr('aria-activedescendant', selectedProductId);
  };

  const initDropdown = () => {
    const index = Number(SiteUtilities.getParameterByName('preset_product')) || 0;
    const productList = jQuery('.product-dropdown-box .pricing-product-list')[index];
    const firstOption = jQuery(productList).find('.pricing-product-name').clone();
    updateActiveDescendant(productList);
    jQuery(pricingProductInputEle).empty().append(firstOption, arrowEle);
  };

  initDropdown();

  const toggleOverLay = (enableOverLay = false) => {
    if (enableOverLay) {
      jQuery(overlayEle).addClass('active');
      jQuery(pricingTableEles).css('position', 'relative');
      jQuery(pricingProductInputEle).attr('aria-expanded', 'true');
    } else {
      jQuery(overlayEle).removeClass('active');
      jQuery(pricingTableEles).css('position', 'static');
      jQuery(pricingProductInputEle).attr('aria-expanded', 'false');
    }
  };

  jQuery(document).on('click', function (event) {
    var targetClass = '.product-dropdown-box, .pricing-product-input, .pricing-product-name, .product-name-tag, .icon-arrow-down';
    if (event.target && !event.target.matches(targetClass)) {
      jQuery(targetClass).removeClass('active');
      ResponsiveUtilities.onDeviceType('desktop', toggleOverLay(false));
    }
  });

  jQuery(pricingProductInputEle).on('click', function () {
    jQuery(pricingDropdownEle).find('.product-dropdown-box').toggleClass('active');
    jQuery(pricingDropdownEle).find('.icon-arrow-down').toggleClass('active');
    const isDropdownExpanded = jQuery(pricingDropdownEle).find('.product-dropdown-box').hasClass('active');
    ResponsiveUtilities.onDeviceType('desktop', toggleOverLay(isDropdownExpanded));
  });

  jQuery('.pricing-product-list').on('click', function () {
    const selectedProduct = jQuery(this).find('[data-product-name]').clone();
    updateActiveDescendant(this);
    jQuery(pricingProductInputEle).empty().append(selectedProduct, arrowEle);
    jQuery(pricingDropdownEle).find('.product-dropdown-box').removeClass('active');
    jQuery(pricingDropdownEle).find('.icon-arrow-down').removeClass('active');
    ResponsiveUtilities.onDeviceType('desktop', toggleOverLay(false));
  });
};
export { pricingDropdown };
